/**
 * Collection Page — Client-side Interactions
 * Handles:
 *   - Region page: country search filter + filter tabs + sort
 *   - Country page: pill filters + variant grid selector + add-to-cart
 *   - Scroll animations
 */
(function () {
  'use strict';

  /* ==========================================================
     REGION PAGE: Type Filter Tabs + Destination Dropdown + Legacy Search
     ========================================================== */
  function initRegionPage() {
    var productsContainer = document.querySelector('[data-cp-products]');
    if (!productsContainer) return;

    // Early return: this function is for region pages only (has type tabs or destination dropdown)
    var hasTypeTabs = document.querySelector('[data-cp-type-tab]');
    var hasDestDropdown = document.getElementById('cp-sort-toggle');
    if (!hasTypeTabs && !hasDestDropdown) return;

    // Sort: eSIM first, Physical SIM last
    // Only sort if there are physical SIM cards in the mix
    var allCards = Array.from(productsContainer.querySelectorAll('[data-cp-card]'));
    var hasPhysical = allCards.some(function (c) { return (c.getAttribute('data-type') || '').indexOf('physical') !== -1; });
    if (hasPhysical) {
      allCards.sort(function (a, b) {
        var aType = a.getAttribute('data-type') || '';
        var bType = b.getAttribute('data-type') || '';
        var aPhysical = aType.indexOf('physical') !== -1 ? 1 : 0;
        var bPhysical = bType.indexOf('physical') !== -1 ? 1 : 0;
        return aPhysical - bPhysical;
      });
      // Use DocumentFragment to batch DOM operations
      var frag = document.createDocumentFragment();
      allCards.forEach(function (card) { frag.appendChild(card); });
      productsContainer.appendChild(frag);
    }

    var cards = productsContainer.querySelectorAll('[data-cp-card]');
    var emptyState = document.querySelector('[data-cp-empty]');

    // Filter state
    var filterState = { type: 'all', dest: 'all' };

    function applyFilters() {
      var visibleCount = 0;
      cards.forEach(function (card) {
        var cardType = card.getAttribute('data-type') || 'country';
        /* Primary: stable handle-based key (language-independent) */
        var countryKey = (card.getAttribute('data-cp-country-key') || '').toLowerCase();
        /* Fallback: display text (for cards without key) */
        var countryDisplay = (card.getAttribute('data-cp-country') || '').toLowerCase();

        var matchType = filterState.type === 'all' || cardType.indexOf(filterState.type) !== -1;
        var matchDest = filterState.dest === 'all'
          || countryKey === filterState.dest
          || countryKey.indexOf(filterState.dest) !== -1
          || countryDisplay.indexOf(filterState.dest) !== -1;

        if (matchType && matchDest) {
          card.style.display = '';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });
      if (emptyState) {
        emptyState.style.display = visibleCount === 0 ? '' : 'none';
      }
    }

    // New type filter tabs (data-cp-type-tab: all / country / regional)
    var typeTabs = document.querySelectorAll('[data-cp-type-tab]');
    typeTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        filterState.type = this.getAttribute('data-cp-type-tab');
        typeTabs.forEach(function (t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
        applyFilters();
      });
    });

    // Legacy tab support (data-cp-tab)
    var legacyTabs = document.querySelectorAll('[data-cp-tab]');
    legacyTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        filterState.type = this.getAttribute('data-cp-tab');
        legacyTabs.forEach(function (t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
        applyFilters();
      });
    });

    // Destination dropdown
    initDestinationDropdown(cards, filterState, applyFilters);

    // Legacy search (from old region hero)
    var searchInput = document.querySelector('[data-cp-country-search]');
    var clearBtn = document.querySelector('[data-cp-country-search-clear]');
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        filterState.dest = this.value.trim().toLowerCase();
        if (clearBtn) clearBtn.classList.toggle('is-visible', this.value.trim().length > 0);
        applyFilters();
      });
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          searchInput.value = '';
          filterState.dest = 'all';
          clearBtn.classList.remove('is-visible');
          applyFilters();
        });
      }
    }

    // Legacy sort select
    var sortSelect = document.querySelector('[data-cp-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortCards(this.value, productsContainer, cards);
      });
    }
  }

  /* ==========================================================
     DESTINATION DROPDOWN
     ========================================================== */
  function initDestinationDropdown(cards, filterState, applyFilters) {
    var toggle = document.getElementById('cp-sort-toggle');
    var dropdown = document.getElementById('cp-sort-dropdown');
    var labelEl = document.getElementById('cp-sort-label');
    if (!toggle || !dropdown) return;

    // Collect unique destinations using stable handle-based key + display label
    var destinations = [];
    var destinationMap = {};
    cards.forEach(function (card) {
      var key = (card.getAttribute('data-cp-country-key') || '').trim().toLowerCase();
      var label = (card.getAttribute('data-cp-country') || '').trim();
      if (!key && label) key = label.toLowerCase();
      if (key && !destinationMap[key]) {
        destinationMap[key] = label || key;
        destinations.push({ label: label || key, value: key });
      }
    });
    destinations.sort(function (a, b) { return a.label.localeCompare(b.label, undefined, {sensitivity: 'base'}); });

    // Build dropdown options as DOM nodes (textContent-safe; no HTML injection
    // from product/collection-derived destination labels).
    var section = document.getElementById('region-products');
    var i18nAllDest = section ? section.getAttribute('data-i18n-all-destinations') || 'All Destinations' : 'All Destinations';
    dropdown.textContent = '';
    var allOpt = document.createElement('div');
    allOpt.className = 'cp-sort-option is-active';
    allOpt.setAttribute('data-dest', 'all');
    allOpt.textContent = i18nAllDest;
    dropdown.appendChild(allOpt);
    destinations.forEach(function (dest) {
      var opt = document.createElement('div');
      opt.className = 'cp-sort-option';
      opt.setAttribute('data-dest', dest.value);
      opt.textContent = dest.label;
      dropdown.appendChild(opt);
    });

    // Toggle open/close — ignore clicks from inside dropdown
    toggle.addEventListener('click', function (e) {
      if (e.target.closest('.cp-sort-option')) return; /* don't toggle when option clicked */
      e.stopPropagation();
      var isOpen = dropdown.classList.contains('is-open');
      dropdown.classList.toggle('is-open', !isOpen);
      var chevron = toggle.querySelector('.cp-filters__sort-chevron');
      if (chevron) chevron.style.transform = isOpen ? '' : 'rotate(180deg)';
    });

    document.addEventListener('click', function (e) {
      if (!toggle.contains(e.target)) {
        dropdown.classList.remove('is-open');
        var chevron = toggle.querySelector('.cp-filters__sort-chevron');
        if (chevron) chevron.style.transform = '';
      }
    });

    // Option selection
    dropdown.addEventListener('click', function (e) {
      var opt = e.target.closest('.cp-sort-option');
      if (!opt) return;
      e.stopPropagation(); /* prevent bubble to toggle handler */
      var dest = (opt.getAttribute('data-dest') || 'all').trim().toLowerCase();
      filterState.dest = dest;
      if (labelEl) {
        labelEl.textContent = dest === 'all' ? i18nAllDest : opt.textContent.trim();
      }
      dropdown.querySelectorAll('.cp-sort-option').forEach(function (o) {
        o.classList.toggle('is-active', o === opt);
      });
      dropdown.classList.remove('is-open');
      var chevron = toggle.querySelector('.cp-filters__sort-chevron');
      if (chevron) chevron.style.transform = '';
      applyFilters();
    });
  }

  /* ==========================================================
     SORT CARDS
     ========================================================== */
  function sortCards(sortBy, container, cards) {
    var arr = Array.prototype.slice.call(cards);

    arr.sort(function (a, b) {
      switch (sortBy) {
        case 'price-asc':
          return parsePrice(a) - parsePrice(b);
        case 'price-desc':
          return parsePrice(b) - parsePrice(a);
        case 'name-asc':
          var nameA = (a.getAttribute('data-cp-country') || a.querySelector('.pc__name')?.textContent || '').toLowerCase();
          var nameB = (b.getAttribute('data-cp-country') || b.querySelector('.pc__name')?.textContent || '').toLowerCase();
          return nameA.localeCompare(nameB);
        default:
          return 0;
      }
    });

    var frag = document.createDocumentFragment();
    arr.forEach(function (card) { frag.appendChild(card); });
    container.appendChild(frag);
  }

  function parsePrice(card) {
    var priceEl = card.querySelector('.pc__price') || card.querySelector('.pc__summary-price');
    if (!priceEl) return 0;
    return parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0;
  }

  /* ==========================================================
     COUNTRY PAGE: Pill Filters + Variant Grid + Add to Cart
     ========================================================== */
  function initCountryPage() {
    var pills = document.querySelectorAll('[data-cp-filter]');
    var container = document.querySelector('[data-cp-products]');
    if (!container || pills.length === 0) return;

    var cards = container.querySelectorAll('[data-cp-card]');
    var emptyState = container.querySelector('[data-cp-empty]');
    var activeFilters = { data: 'all', validity: 'all' };

    // Pill click handlers
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = this.getAttribute('data-cp-group');
        var value = this.getAttribute('data-cp-filter');
        activeFilters[group] = value;

        document.querySelectorAll('[data-cp-group="' + group + '"]').forEach(function (p) {
          p.classList.remove('is-active');
        });
        this.classList.add('is-active');

        applyPillFilters();
      });
    });

    function applyPillFilters() {
      var visibleCount = 0;

      cards.forEach(function (card) {
        var dataTags = (card.getAttribute('data-cp-data') || '').toLowerCase().split(',');
        var validityTags = (card.getAttribute('data-cp-validity') || '').toLowerCase().split(',');

        var matchData = activeFilters.data === 'all' || dataTags.indexOf(activeFilters.data.toLowerCase()) !== -1;
        var matchValidity = activeFilters.validity === 'all' || validityTags.indexOf(activeFilters.validity.toLowerCase()) !== -1;

        if (matchData && matchValidity) {
          card.style.display = '';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });

      if (emptyState) {
        emptyState.style.display = visibleCount === 0 ? '' : 'none';
      }
    }
  }

  /* ==========================================================
     VARIANT GRID SELECTOR
     ========================================================== */
  function initVariantGrids() {
    var grids = document.querySelectorAll('[data-pc-variants]');

    grids.forEach(function (grid) {
      var card = grid.closest('[data-cp-card]');
      if (!card) return;

      var variants = grid.querySelectorAll('.pc__variant');
      var summarySpec = card.querySelector('[data-pc-summary-spec]');
      var summaryPrice = card.querySelector('[data-pc-summary-price]');
      var buyBtn = card.querySelector('[data-pc-buy]');

      variants.forEach(function (variant) {
        variant.addEventListener('click', function () {
          // Update selection state
          variants.forEach(function (v) { v.classList.remove('is-selected'); });
          this.classList.add('is-selected');

          var variantId = this.getAttribute('data-variant-id');
          var price = this.getAttribute('data-variant-price');
          var dataVal = this.getAttribute('data-variant-data');
          var daysVal = this.getAttribute('data-variant-days');
          var isAvailable = this.getAttribute('data-variant-available') === 'true';

          // Update summary
          if (summarySpec) {
            var specText = dataVal;
            if (daysVal) specText += ' \u00B7 ' + daysVal;
            summarySpec.textContent = specText;
          }

          if (summaryPrice) {
            summaryPrice.textContent = price;
          }

          // Update buy button
          if (buyBtn) {
            buyBtn.setAttribute('data-variant-id', variantId);
            buyBtn.disabled = !isAvailable;
            buyBtn.textContent = isAvailable ? 'Buy Now' : 'Sold Out';
          }
        });
      });
    });
  }

  /* ==========================================================
     BUY NOW / ADD TO CART
     ========================================================== */
  function initBuyButtons() {
    document.querySelectorAll('[data-pc-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.disabled || this.classList.contains('is-loading')) return;

        /* AT&T / T-Mobile physical SIMs capture a REQUIRED activation date on the
           PDP. Quick-add posts no line-item properties, so adding them straight
           to cart creates an order with no activation date. Route these clicks to
           the product page instead, where the guarded date field is captured. */
        if (this.hasAttribute('data-pc-needs-date')) {
          var pdpUrl = this.getAttribute('data-pc-url');
          if (pdpUrl) { window.location.href = pdpUrl; return; }
        }

        var variantId = this.getAttribute('data-variant-id');
        if (!variantId) return;

        addToCart(this, variantId);
      });
    });
  }

  function addToCart(btn, variantId) {
    btn.classList.add('is-loading');
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';

    fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1
        }]
      })
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(function (data) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.textContent = 'Added!';

      showToast(data.items ? data.items[0] : data);
      updateCartCount();

      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.disabled = false;
        btn.textContent = originalText;
      }, 2000);
    })
    .catch(function () {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.textContent = 'Error — Try Again';

      setTimeout(function () {
        btn.textContent = originalText;
      }, 2000);
    });
  }

  /* ==========================================================
     CART COUNT UPDATE
     ========================================================== */
  function updateCartCount() {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var countEls = document.querySelectorAll('[data-cart-count], .cart-count-badge, .m-cart-count');
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) {
          el.classList.add('has-items');
          el.style.display = '';
        }
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    })
    .catch(function () {});
  }

  /* ==========================================================
     TOAST NOTIFICATION
     ========================================================== */
  function showToast() {
    var existing = document.querySelector('.cp-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'cp-toast';
    toast.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="20" height="20">' +
        '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>' +
        '<polyline points="22 4 12 14.01 9 11.01"></polyline>' +
      '</svg>' +
      '<span>Added to cart!</span>' +
      '<a href="/cart" style="margin-left:auto;font-weight:700;color:var(--cp-accent,#5B6ABF);">View Cart</a>';

    toast.style.cssText = 'position:fixed;bottom:24px;right:24px;background:#fff;padding:14px 20px;border-radius:16px;' +
      'box-shadow:0 8px 30px rgba(0,0,0,0.15);display:flex;align-items:center;gap:10px;z-index:9999;' +
      'transform:translateY(120%);transition:transform 0.4s cubic-bezier(0.16,1,0.3,1);font-size:0.9rem;min-width:280px;';

    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.style.transform = 'translateY(0)';
    });

    setTimeout(function () {
      toast.style.transform = 'translateY(120%)';
      setTimeout(function () {
        if (toast.parentNode) toast.remove();
      }, 400);
    }, 4000);
  }

  /* ==========================================================
     SCROLL ANIMATIONS
     ========================================================== */
  function initScrollAnimations() {
    var animateEls = document.querySelectorAll('.cp-animate');
    if (animateEls.length === 0) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.1
      });

      animateEls.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      animateEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  /* ==========================================================
     INITIALIZE
     ========================================================== */
  function init() {
    initRegionPage();
    initCountryPage();
    initVariantGrids();
    initBuyButtons();
    initScrollAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
